import React, { useEffect, useState } from "react";
import { Fragment } from "react";
import {
  Box,
  Paper,
} from "@mui/material";
import { getNotificationPermission, notificationChannelTypes, notificationListPageSize, notificationStatusHeaders } from "./notificationConstant";
import Alert from "../layout/Alert";
import { selectMenuProps } from "../../utils/selectMenuProps";
import PhoneInput from "react-phone-input-2";
import { format } from "date-fns";
import FileCopyIcon from '@mui/icons-material/FileCopy';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import SearchIcon from '@mui/icons-material/Search';
import VisibilityIcon from '@mui/icons-material/Visibility';
import IncrementalPagination from "../Common/DataTable/IncrementalPagination";
import { useTheme } from "@mui/material/styles";
import AppButton from "../Common/Button/Button";
import AppIconButton from "../Common/Button/IconButton";
import { useDesignTokens } from "../../theme/useDesignTokens";
import FormInput from "../Common/FormInputs/MuiTextField";
import DataTable from "../Common/DataTable/DataTable";
import { SearchSectionLabel, SectionHeading, LabelText } from "../Common/Typography/AppTypography";




const searchInputHeight = 45;
const defaultBorderColor = "rgba(0, 0, 0, 0.23)";
const filterCardSx = {
  p: 2,
  boxShadow: 2,
  borderRadius: 1,
  overflow: "visible",
  minWidth: 0,
};
const searchCardSx = {
  ...filterCardSx,
  boxShadow: "none",
  border: "none",
};

const severityOptions = [
    { label: "None", value: null },
    { label: "Info", value: "info" },
    { label: "Alert", value: 'alert' },
    { label: 'Recommendation', value: "recommendation" },
    { label: "Promotion", value: "promotion" }]

const FindNotification = ({ notificationData = {},
    getNotificationTask = () => { },
    searchNotificationsByUserId = () => { },
    searchNotifications = () => { },
    allowedCountries,
    userData,
    tenantData,
    setDialog,
    setDialogContents,
    setDialogTab,
    userRoles = []
    //setCustomAlert
}) => {

    let searchOptions = []
    if (getNotificationPermission(userRoles, 'getNotificationList')) {
        searchOptions = [
            { label: "User ID", value: "userId", placeholder: "Enter User ID" },
            { label: "User E-mail ID", value: 'email', placeholder: "Enter User Email ID" },
            { label: 'User Mobile no', value: "mobile", placeholder: "Enter Mobile no without code" }
        ]
    }
    if (getNotificationPermission(userRoles, 'getNotificationTask')) {
        searchOptions = [...searchOptions,
        { label: "Task ID", value: "taskId", placeholder: "Enter Task ID" }
        ]
    }

    // add key value pair for any new column to be added to the table. 
    // Key should be same as the key in the response and value should be what you want the header for the column to be
    const notificationHeaders =
    {
        uniqueId: { label: "Unique Id" },
        // notificationType: { label: "Type" },
        sentAt: { label: "Created At" },
        severity: { label: "Severity" },
        action: { label: "Actions", style: { justifyContent: "start" } }
    }

    const [notificationList, setNotificationList] = useState([]);
    const [taskId, setTaskId] = useState({ value: "", textValue: "" });
    const [showNotificationList, setShowNotificationList] = useState(false);
    const [searchBy, setSearchBy] = useState(searchOptions[0]?.value)
    const [countryCode, setCountryCode] = useState("91");
    const [searchStr, setSearchStr] = useState("");
    const [tableHeaders, setTableHeaders] = useState({});
    const [pageIndex, setPageIndex] = useState(1);
    const [severityFilter, setSeverityFilter] = useState(null);
    const theme = useTheme();
    const { colors } = useDesignTokens();
    const primaryColor = colors?.primary?.main || theme.palette.primary.main;
    const openDialogSafely = () => {
      if (typeof document !== "undefined" && document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
      setDialog(true);
    };
    const focusOutlineSx = {
      "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: `${primaryColor} !important`,
        borderWidth: "1px",
      },
      "& .MuiInputLabel-root.Mui-focused": {
        color: `${primaryColor} !important`,
      },
    };

    const phoneInputSx = {
      width: { xs: 50, sm: 54 },
      height: searchInputHeight,
      minHeight: searchInputHeight,
      maxHeight: searchInputHeight,
      flexShrink: 0,
      alignSelf: "stretch",
      overflow: "visible",
      "& .react-tel-input": {
        width: "100%",
        height: searchInputHeight,
        minHeight: searchInputHeight,
        maxHeight: searchInputHeight,
        margin: 0,
        overflow: "visible",
      },
      "& .react-tel-input .form-control": {
        display: "none !important",
        width: "0 !important",
        minWidth: "0 !important",
        height: `${searchInputHeight}px !important`,
        minHeight: searchInputHeight,
        borderRadius: "4px 0 0 4px",
        borderRight: "none",
        borderColor: "transparent",
        paddingLeft: "0",
        paddingRight: "0",
        fontSize: "14px",
        color: "transparent",
        backgroundColor: "transparent",
        boxShadow: "none",
        pointerEvents: "none",
      },
      "& .react-tel-input .flag-dropdown": {
        height: `${searchInputHeight}px !important`,
        minHeight: `${searchInputHeight}px !important`,
        maxHeight: `${searchInputHeight}px !important`,
        top: 0,
        margin: 0,
        borderRadius: "4px 0 0 4px",
        border: `1px solid ${defaultBorderColor} !important`,
        backgroundColor: theme.palette.background.paper,
        width: { xs: "50px", sm: "54px" },
        boxSizing: "border-box",
        zIndex: 2,
        position: "relative",
        overflow: "visible",
      },
      "& .react-tel-input .flag-dropdown.open": {
        border: "1px solid #ff8802 !important",
      },
      "& .react-tel-input .flag-dropdown.open .selected-flag": {
        position: "relative",
        zIndex: 3,
        borderRight: "1px solid #ff8802",
        borderBottom: "1px solid #ff8802",
      },
      "& .react-tel-input .selected-flag": {
        height: searchInputHeight,
        width: { xs: 50, sm: 54 },
        padding: "0 0 0 10px",
      },
      "& .react-tel-input .selected-flag:hover": {
        backgroundColor: "transparent !important",
      },
      "& .react-tel-input .country-list": {
        border: `1px solid ${defaultBorderColor}`,
        backgroundColor: "#fff",
        boxSizing: "border-box",
        boxShadow: "0 2px 6px rgba(0, 0, 0, 0.2)",
        marginTop: 2,
        marginLeft: 0,
        zIndex: 3,
      },
    };

    const searchNotificationData = (pg, severity = null) => {
        switch (searchBy) {
            case "userId":
                searchNotificationsByUserId(searchStr, pg, severity)
                break;
            case "mobile":
            case "email":
                searchNotificationsByUserId(userData?.user?.userId, pg, severity)
                break;
            default:
                break;
        }
    }

    const getNextPage = () => {
        const newPg = pageIndex + 1
        setPageIndex(newPg);
        searchNotificationData(newPg, severityFilter);
    }

    const getPrevPage = () => {
        const newPg = pageIndex - 1;
        setPageIndex(newPg);
        searchNotificationData(newPg, severityFilter);
    }

    const onSubmit = (e) => {
        e?.preventDefault();
        setShowNotificationList(true);
        setPageIndex(1);

        switch (searchBy) {
            case "userId":
                searchNotificationsByUserId(searchStr)
                break;
            case "taskId":
                getNotificationTask(taskId?.textValue);
                break;
            case "mobile":
                searchNotifications(searchBy, `+${countryCode}${searchStr}`, 1, tenantData?.tenantId)
                break;
            case "email":
                searchNotifications(searchBy, searchStr, 1, tenantData?.tenantId)
                break;
            default:
                break;
        }
    }
    useEffect(() => {
        if (showNotificationList) {
            if (notificationData?.lastAction?.includes("get_notification_task") && taskId?.textValue !== "" && notificationData?.lastAction?.includes(taskId?.textValue)) {
                // dont remove second and third condititon-check after setTimeout call from previous page is executed and get empty data after data is populated in table
                setNotificationList(JSON.stringify(notificationData?.notificationDetails) !== "{}" ? [{
                    fullTaskId: notificationData?.notificationDetails?.taskId,
                    taskId: <div title={notificationData?.notificationDetails?.taskId}>
                        {
                            "..." + notificationData?.notificationDetails?.taskId?.slice(notificationData?.notificationDetails?.taskId?.length - 6, notificationData?.notificationDetails?.taskId?.length)
                        }
                    </div>,
                    userCount: <div title="The expected number of users that will receive the  notification.">
                        {
                            notificationData?.notificationDetails?.status?.notificationProcessStatus?.userSentCount
                        }
                    </div>,
                    expectedUserCount: <div title={"The number of users that received the notification."}>
                        {
                            notificationData?.notificationDetails?.status?.taskProcessStatus?.userCount + notificationData?.notificationDetails?.status?.taskProcessStatus?.userFailedCount
                        }
                    </div>,
                    taskStatus: notificationData?.notificationDetails?.status?.taskStatus,
                    failureCount: <div title="The number of users the notification failed to reach.">
                        {notificationData?.notificationDetails?.status?.notificationProcessStatus?.failedUserSentCount + notificationData?.notificationDetails?.status?.notificationProcessStatus?.tokenNotFoundUserCount + notificationData?.notificationDetails?.status?.taskProcessStatus?.userFailedCount
                        }
                    </div>,
                    notificationType: notificationChannelTypes[notificationData?.notificationDetails?.channel?.type + "Notification"]?.label,
                    severity: notificationData?.notificationDetails?.severity,
                    createdAt: format(new Date(notificationData?.notificationDetails?.creationDate * 1000), "dd MMM yyyy 'AT' hh:mm a"),
                    expiryDate: format(new Date(notificationData?.notificationDetails?.expiry * 1000), "dd MMM yyyy 'AT' hh:mm a"),
                    payload: { ...notificationData?.notificationDetails },
                    msg: notificationData?.notificationDetails?.message?.payload,
                    copied:false,
                    action: (data) => (
                        <AppButton
                          variant="primary"
                          size="small"
                          onClick={() => {
                            setDialogContents({ title: "Notification Details", content: "notificationDetails", data })
                            openDialogSafely();
                            setDialogTab(0);
                          }}
                        >
                          View
                        </AppButton>
                    )

                }] : [])
            }
            else if (notificationData?.lastAction?.includes("search_notification")) {
                setNotificationList(notificationData?.notificationDetails?.map(n => {
                    return {
                        sentAt: format(new Date(n?.ts * 1000), "dd MMM yyyy 'AT' hh:mm a"),
                        severity: n?.severity,
                        payload: { ...n },
                        fullUniqueId: n?.uniqueId,
                        uniqueId: <div title={n?.uniqueId}>
                            {
                                "..." + n?.uniqueId?.substring(n?.uniqueId?.length - 6, n?.uniqueId?.length)
                            }
                        </div>,
                        msg: n?.message?.payload,
                        copied:false,
                        action: (data) => (
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "start",
                                alignItems: "center",
                                width: "100%",
                              }}
                            >
                              <AppIconButton
                                variant="primary"
                                size="small"
                                icon={<VisibilityIcon fontSize="small" />}
                                tooltip="View notification"
                                onClick={() => {
                                  setDialogContents({
                                    title: "Notification Details",
                                    content: "userNotificationDetails",
                                    data,
                                  });
                                  openDialogSafely();
                                  setDialogTab(0);
                                }}
                              />
                            </Box>
                        )

                    }
                }))
            }
            setTableHeaders(searchBy === "taskId" ? notificationStatusHeaders : notificationHeaders)
        }
    }, [notificationData?.lastAction])
    const handlePageChange = (newPage) => {
        const currentPage = pageIndex - 1;
        if (newPage > currentPage) {
            getNextPage();
        } else if (newPage < currentPage) {
            getPrevPage();
        }
    };

    const handlePageSizeChange = () => {
        // Page size is controlled via notificationListPageSize constant for now.
    };

    const notificationTableData = notificationList
      .map((element, index) => ({
        ...element,
        originalIndex: index,
        rowId:
          element?.fullTaskId ||
          element?.fullUniqueId ||
          `${pageIndex}-${index}`,
      }));

    const notificationTableColumns = Object.keys(tableHeaders).map((key) => ({
      key,
      label: tableHeaders[key]?.label,
      align:
        tableHeaders[key]?.style?.justifyContent === "center"
          ? "center"
          : tableHeaders[key]?.style?.justifyContent === "flex-end"
            ? "right"
            : "left",
      justifyContent: tableHeaders[key]?.style?.justifyContent,
      width: key === "action" ? 110 : undefined,
      minWidth: key === "action" ? 110 : undefined,
      headerCellSx: {
        backgroundColor: "background.paper",
      },
      cellSx: {
        textAlign:
          tableHeaders[key]?.style?.justifyContent === "center"
            ? "center"
            : undefined,
      },
      render: (value, row) => {
        const cellValue =
          row?.hasOwnProperty(key)
            ? typeof row[key] === "function"
              ? row[key](row)
              : row[key]
            : "-";
        const isLong = String(cellValue).length > 200;

        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent:
                tableHeaders[key]?.style?.justifyContent === "center"
                  ? "center"
                  : key === "action" || tableHeaders[key]?.style?.justifyContent === "flex-end"
                    ? "flex-end"
                  : "flex-start",
              gap: 1,
              width: "100%",
              whiteSpace: isLong ? "normal" : "nowrap",
              wordBreak: isLong ? "break-word" : "normal",
            }}
          >
            {cellValue}
            {(key === "taskId" || key === "uniqueId") && (
              <AppIconButton
                size="small"
                variant="ghost"
                tooltip="Copy"
                onClick={() => {
                  setNotificationList(notificationList?.map((n, i) => {
                    if (i === row.originalIndex) {
                      n.copied = true;
                    }
                    return n;
                  }));
                  setTimeout(() => {
                    setNotificationList(notificationList?.map((n, i) => {
                      if (i === row.originalIndex) {
                        n.copied = false;
                      }
                      return n;
                    }));
                  }, 3000);
                  navigator?.clipboard?.writeText(row?.fullTaskId || row?.fullUniqueId);
                }}
                icon={row?.copied ? <CheckCircleOutlineIcon /> : <FileCopyIcon />}
              />
            )}
          </Box>
        );
      },
    }));

    return (
        <Fragment>
            <Box sx={{ width: "100%", maxWidth: "100%", minWidth: 0, boxSizing: "border-box" }}>
                <Paper sx={searchCardSx}>
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: { xs: "1fr", md: "auto 1fr" },
                      rowGap: 2,
                      columnGap: { xs: 2, md: "116px" },
                      alignItems: "center",
                    }}
                  >
                    <SectionHeading sx={{ mb: 0 }}>
                      Search Notification
                    </SectionHeading>
                    <Box
                      component="form"
                      onSubmit={onSubmit}
                      sx={{
                        display: "grid",
                        gap: 1.5,
                        alignItems: "center",
                        width: "100%",
                        gridTemplateColumns: {
                          xs: "1fr",
                          md: "90px 200px minmax(220px, 320px) 100px",
                        },
                        justifyContent: "start",
                      }}
                    >
                      <SearchSectionLabel>Search By</SearchSectionLabel>
                      <FormInput
                        type="select"
                        size="small"
                        fullWidth
                        name="searchBy"
                        value={searchBy}
                        onChange={(e) => {
                          setSearchStr("");
                          setShowNotificationList(false);
                          setSearchBy(e?.target?.value);
                        }}
                        options={searchOptions?.map((o) => ({
                          value: o?.value,
                          label: o?.label,
                        })) || []}
                        MenuProps={selectMenuProps}
                        sx={{
                          width: { xs: "100%", md: "auto" },
                          minWidth: { xs: "100%", md: 200 },
                          maxWidth: { xs: "100%", md: 200 },
                          ...focusOutlineSx,
                        }}
                      />
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "stretch",
                          gap: { xs: 0, sm: 1 },
                          flexWrap: "nowrap",
                          width: "100%",
                          minWidth: 0,
                        }}
                      >
                        {searchBy !== "taskId" ? (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "stretch",
                              flex: "1 1 auto",
                              minWidth: 0,
                              width: "100%",
                              maxWidth: "100%",
                              overflow: "hidden",
                              "&:focus-within .react-tel-input .flag-dropdown": {
                                border: "1px solid #ff8802 !important",
                              },
                              "&:focus-within .MuiOutlinedInput-notchedOutline": {
                                borderWidth: "1px !important",
                              },
                            }}
                          >
                            {searchBy === "mobile" && (
                              <Box sx={phoneInputSx}>
                                <PhoneInput
                                  enableSearch={false}
                                  value={countryCode}
                                  onChange={setCountryCode}
                                  onlyCountries={allowedCountries}
                                />
                              </Box>
                            )}
                            <FormInput
                              required
                              fullWidth
                              size="small"
                              placeholder={searchOptions?.find(o => o?.value === searchBy)?.placeholder}
                              type={searchBy === "mobile" ? "text" : "text"}
                              inputProps={{ inputMode: searchBy === "mobile" ? "numeric" : undefined }}
                              name="text"
                              value={searchStr}
                              onChange={(e) => {
                                setSearchStr(e?.target?.value)
                                setShowNotificationList(false)
                              }}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  onSubmit(e);
                                }
                              }}
                              startAdornment={searchBy === "mobile" ? null : <SearchIcon fontSize="small" />}
                              sx={{
                                minWidth: 0,
                                width: "100%",
                                "& .MuiOutlinedInput-root": {
                                  height: searchInputHeight,
                                  alignItems: "center",
                                  borderTopLeftRadius: searchBy === "mobile" ? 0 : undefined,
                                  borderBottomLeftRadius: searchBy === "mobile" ? 0 : undefined,
                                  boxShadow: "none",
                                  "&.Mui-focused": {
                                    boxShadow: "none",
                                  },
                                },
                                "& .MuiInputAdornment-root": {
                                  height: searchInputHeight,
                                  maxHeight: searchInputHeight,
                                  alignItems: "center",
                                  marginTop: 0,
                                  marginBottom: 0,
                                },
                                "& .MuiInputAdornment-root svg": {
                                  display: "block",
                                  fontSize: 20,
                                  verticalAlign: "middle",
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                  boxShadow: "none",
                                  borderColor: defaultBorderColor,
                                  borderLeft: searchBy === "mobile" ? "none !important" : undefined,
                                },
                                "& .MuiInputBase-input": {
                                  boxShadow: "none",
                                  outline: "none",
                                  borderBottom: "none !important",
                                },
                                "& .MuiInputBase-input:focus": {
                                  borderBottom: "none !important",
                                  boxShadow: "none !important",
                                },
                                "& .MuiInputBase-input:focus-visible": {
                                  borderBottom: "none !important",
                                  boxShadow: "none !important",
                                },
                                "& input": {
                                  borderBottom: "none !important",
                                },
                                "& input:focus": {
                                  borderBottom: "none !important",
                                  boxShadow: "none",
                                },
                                "& input:focus-visible": {
                                  borderBottom: "none !important",
                                  boxShadow: "none",
                                },
                                ...focusOutlineSx,
                              }}
                            />
                          </Box>
                        ) : (
                          <FormInput
                            type="text"
                            size="small"
                            fullWidth
                            name="taskId"
                            placeholder="Enter Task ID"
                            value={taskId?.textValue || ""}
                            onChange={(e) => {
                              const value = e.target.value || "";
                              setTaskId({ value, textValue: value });
                              setShowNotificationList(false);
                            }}
                            startAdornment={<SearchIcon fontSize="small" />}
                            sx={{
                              flex: "1 1 280px",
                              minWidth: 0,
                              ...focusOutlineSx,
                            }}
                          />
                        )}
                      </Box>
                      <AppButton
                        type="submit"
                        variant="primary"
                        size="medium"
                        sx={{
                          height: searchInputHeight,
                          width: { xs: "100%", md: "auto" },
                          justifySelf: { xs: "start", md: "start" },
                          minWidth: 100,
                        }}
                      >
                        Search
                      </AppButton>
                    </Box>
                  </Box>
                </Paper>
                <Alert />
                {showNotificationList && (
                    <Paper sx={{ ...filterCardSx, mt: 2 }}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            flexWrap: "wrap",
                            gap: 1.5,
                            mb: 2,
                            minWidth: 0,
                            width: "100%",
                            overflow: "visible",
                          }}
                        >
                            {searchBy === "taskId" ? (
                              getNotificationPermission(userRoles, "cancelNotification") && (
                                <AppButton
                                  variant="danger"
                                  size="medium"
                                  disabled={notificationList[0]?.taskStatus === "cancelled" || !notificationList[0]?.hasOwnProperty("taskId")}
                                  onClick={() => {
                                    setDialogContents({ title: "Cancel Notification", content: "cancelNotification", data: notificationList[0] })
                                    openDialogSafely();
                                  }}
                                >
                                  Cancel Notification
                                </AppButton>
                              )
                            ) : (
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: { xs: "column", sm: "row" },
                                  alignItems: { xs: "stretch", sm: "center" },
                                  ml: "auto",
                                  gap: 1,
                                  minWidth: 0,
                                  width: { xs: "100%", sm: "auto" },
                                }}
                              >
                                <LabelText noWrap={false} strong>
                                  Filter By Severity
                                </LabelText>
                                <FormInput
                                  type="select"
                                  size="small"
                                  fullWidth={false}
                                  name="severityFilter"
                                  value={severityFilter ?? ""}
                                  onChange={(e) => {
                                    const v =
                                      e?.target?.value === "" || e?.target?.value === "None"
                                        ? null
                                        : e?.target?.value;
                                    setSeverityFilter(v);
                                    setPageIndex(1);
                                    searchNotificationData(1, v);
                                  }}
                                  options={severityOptions.map((o) => ({
                                    value: o.value ?? "",
                                    label: o.label,
                                  }))}
                                  displayEmpty
                                  renderValue={(v) =>
                                    v == null || v === ""
                                      ? "None"
                                      : severityOptions?.find((o) => o?.value === v)?.label || v
                                  }
                                  MenuProps={selectMenuProps}
                                  sx={{
                                    width: { xs: "100%", sm: 220 },
                                    flexShrink: 0,
                                    ...focusOutlineSx,
                                  }}
                                />
                              </Box>
                            )}
                        </Box>
                        <DataTable
                          columns={notificationTableColumns}
                          data={notificationTableData}
                          rowKey="rowId"
                          maxHeight="58vh"
                          minWidth="100%"
                          tableContainerSx={{
                            boxShadow: "none",
                            borderRadius: 0,
                          }}
                          msgForDisplay="No Data found"
                        />
                        {searchBy !== "taskId" && (
                          <IncrementalPagination
                            page={pageIndex - 1}
                            pageSize={notificationListPageSize}
                            dataLength={notificationList.length}
                            onPageChange={handlePageChange}
                            onPageSizeChange={handlePageSizeChange}
                            pageSizeOptions={[notificationListPageSize]}
                            isLastPage={notificationList.length < notificationListPageSize}
                            sx={{ m: 0, mt: 1.5, px: 0 }}
                          />
                        )}
                    </Paper>
                )}
            </Box>
        </Fragment>
    );
};

export default FindNotification;
